import Vue from "vue";
import Vuetify from "vuetify/lib";
import vuetifyEn from "vuetify/lib/locale/en";
import vuetifyJa from "vuetify/lib/locale/ja";

import enMessages from "@/locales/en.json";
import jaMessages from "@/locales/ja.json";

const en = { ...vuetifyEn, ...enMessages };
const ja = { ...vuetifyJa, ...jaMessages };

Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    iconfont: "mdi",
  },
  theme: {
    dark: false,
    themes: {
      light: {
        primary: "#004aad",
        background: "#004aad",
      },
      dark: {
        primary: "#004aad",
      },
    },
  },
  lang: {
    locales: { en, ja },
    current: localStorage.getItem("language")?.substring(0, localStorage.getItem("language")?.indexOf("-")) || "en",
  },
});
